// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic$dForm$dTestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $ExternalOrderOrigin = tag => ({tag});
const $OrderOrigin = (tag, _1) => ({tag, _1});
const TakeawayIsSymbol = {reflectSymbol: () => "Takeaway"};
const UberIsSymbol = {reflectSymbol: () => "Uber"};
const GlovoIsSymbol = {reflectSymbol: () => "Glovo"};
const WoltIsSymbol = {reflectSymbol: () => "Wolt"};
const OnlineIsSymbol = {reflectSymbol: () => "Online"};
const PhoneIsSymbol = {reflectSymbol: () => "Phone"};
const BarIsSymbol = {reflectSymbol: () => "Bar"};
const PortalIsSymbol = {reflectSymbol: () => "Portal"};
const OtherIsSymbol = {reflectSymbol: () => "Other"};
const PyszneIsSymbol = {reflectSymbol: () => "Pyszne"};
const PizzaPortalIsSymbol = {reflectSymbol: () => "PizzaPortal"};
const CustomIsSymbol = {reflectSymbol: () => "Custom"};
const externalOrderOriginIsSymbol = {reflectSymbol: () => "externalOrderOrigin"};
const integratorNameIsSymbol = {reflectSymbol: () => "integratorName"};
const ExternalIntegrationIsSymbol = {reflectSymbol: () => "ExternalIntegration"};
const AndroidAppIsSymbol = {reflectSymbol: () => "AndroidApp"};
const IosAppIsSymbol = {reflectSymbol: () => "IosApp"};
const ApetiloIsSymbol = {reflectSymbol: () => "Apetilo"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)));
const encodeWithOptionsOther = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dGeneric$dClass.readString};
const Takeaway = /* #__PURE__ */ $ExternalOrderOrigin("Takeaway");
const Uber = /* #__PURE__ */ $ExternalOrderOrigin("Uber");
const Glovo = /* #__PURE__ */ $ExternalOrderOrigin("Glovo");
const Wolt = /* #__PURE__ */ $ExternalOrderOrigin("Wolt");
const Online = /* #__PURE__ */ $OrderOrigin("Online");
const Phone = /* #__PURE__ */ $OrderOrigin("Phone");
const Bar = /* #__PURE__ */ $OrderOrigin("Bar");
const Portal = /* #__PURE__ */ $OrderOrigin("Portal");
const Other = /* #__PURE__ */ $OrderOrigin("Other");
const Pyszne = /* #__PURE__ */ $OrderOrigin("Pyszne");
const PizzaPortal = /* #__PURE__ */ $OrderOrigin("PizzaPortal");
const Custom = value0 => $OrderOrigin("Custom", value0);
const ExternalIntegration = value0 => $OrderOrigin("ExternalIntegration", value0);
const AndroidApp = /* #__PURE__ */ $OrderOrigin("AndroidApp");
const IosApp = /* #__PURE__ */ $OrderOrigin("IosApp");
const Apetilo = /* #__PURE__ */ $OrderOrigin("Apetilo");
const toFillFormTypeOrderOrigin = {fillFormDataType: v => "unknown"};
const eqExternalOrderOrigin = {
  eq: x => y => {
    if (x.tag === "Takeaway") { return y.tag === "Takeaway"; }
    if (x.tag === "Uber") { return y.tag === "Uber"; }
    if (x.tag === "Glovo") { return y.tag === "Glovo"; }
    if (x.tag === "Wolt") { return y.tag === "Wolt"; }
    return false;
  }
};
const eqOrderOrigin = {
  eq: x => y => {
    if (x.tag === "Online") { return y.tag === "Online"; }
    if (x.tag === "Phone") { return y.tag === "Phone"; }
    if (x.tag === "Bar") { return y.tag === "Bar"; }
    if (x.tag === "Portal") { return y.tag === "Portal"; }
    if (x.tag === "Other") { return y.tag === "Other"; }
    if (x.tag === "Pyszne") { return y.tag === "Pyszne"; }
    if (x.tag === "PizzaPortal") { return y.tag === "PizzaPortal"; }
    if (x.tag === "Custom") {
      if (y.tag === "Custom") { return x._1 === y._1; }
      return false;
    }
    if (x.tag === "ExternalIntegration") {
      if (y.tag === "ExternalIntegration") {
        return (() => {
          if (x._1.externalOrderOrigin.tag === "Takeaway") { return y._1.externalOrderOrigin.tag === "Takeaway"; }
          if (x._1.externalOrderOrigin.tag === "Uber") { return y._1.externalOrderOrigin.tag === "Uber"; }
          if (x._1.externalOrderOrigin.tag === "Glovo") { return y._1.externalOrderOrigin.tag === "Glovo"; }
          if (x._1.externalOrderOrigin.tag === "Wolt") { return y._1.externalOrderOrigin.tag === "Wolt"; }
          return false;
        })() && x._1.integratorName === y._1.integratorName;
      }
      return false;
    }
    if (x.tag === "AndroidApp") { return y.tag === "AndroidApp"; }
    if (x.tag === "IosApp") { return y.tag === "IosApp"; }
    if (x.tag === "Apetilo") { return y.tag === "Apetilo"; }
    return false;
  }
};
const ordExternalOrderOrigin = {
  compare: x => y => {
    if (x.tag === "Takeaway") {
      if (y.tag === "Takeaway") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Takeaway") { return Data$dOrdering.GT; }
    if (x.tag === "Uber") {
      if (y.tag === "Uber") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Uber") { return Data$dOrdering.GT; }
    if (x.tag === "Glovo") {
      if (y.tag === "Glovo") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Glovo") { return Data$dOrdering.GT; }
    if (x.tag === "Wolt") {
      if (y.tag === "Wolt") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqExternalOrderOrigin
};
const ordOrderOrigin = {
  compare: x => y => {
    if (x.tag === "Online") {
      if (y.tag === "Online") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Online") { return Data$dOrdering.GT; }
    if (x.tag === "Phone") {
      if (y.tag === "Phone") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Phone") { return Data$dOrdering.GT; }
    if (x.tag === "Bar") {
      if (y.tag === "Bar") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Bar") { return Data$dOrdering.GT; }
    if (x.tag === "Portal") {
      if (y.tag === "Portal") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Portal") { return Data$dOrdering.GT; }
    if (x.tag === "Other") {
      if (y.tag === "Other") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Other") { return Data$dOrdering.GT; }
    if (x.tag === "Pyszne") {
      if (y.tag === "Pyszne") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Pyszne") { return Data$dOrdering.GT; }
    if (x.tag === "PizzaPortal") {
      if (y.tag === "PizzaPortal") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "PizzaPortal") { return Data$dOrdering.GT; }
    if (x.tag === "Custom") {
      if (y.tag === "Custom") { return Data$dOrd.ordString.compare(x._1)(y._1); }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Custom") { return Data$dOrdering.GT; }
    if (x.tag === "ExternalIntegration") {
      if (y.tag === "ExternalIntegration") {
        const v = ordExternalOrderOrigin.compare(x._1.externalOrderOrigin)(y._1.externalOrderOrigin);
        if (v.tag === "LT") { return Data$dOrdering.LT; }
        if (v.tag === "GT") { return Data$dOrdering.GT; }
        return Data$dOrd.ordString.compare(x._1.integratorName)(y._1.integratorName);
      }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ExternalIntegration") { return Data$dOrdering.GT; }
    if (x.tag === "AndroidApp") {
      if (y.tag === "AndroidApp") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "AndroidApp") { return Data$dOrdering.GT; }
    if (x.tag === "IosApp") {
      if (y.tag === "IosApp") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "IosApp") { return Data$dOrdering.GT; }
    if (x.tag === "Apetilo") {
      if (y.tag === "Apetilo") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqOrderOrigin
};
const genericOrderOrigin = {
  to: x => {
    if (x.tag === "Inl") { return Online; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Phone; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Bar; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return Portal; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return Other; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return Pyszne; }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return PizzaPortal; }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return $OrderOrigin("Custom", x._1._1._1._1._1._1._1._1); }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return $OrderOrigin("ExternalIntegration", x._1._1._1._1._1._1._1._1._1); }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return AndroidApp; }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return IosApp; }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return Apetilo; }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Online") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Phone") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Bar") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "Portal") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "Other") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "Pyszne") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "PizzaPortal") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
          )
        )
      );
    }
    if (x.tag === "Custom") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
          )
        )
      );
    }
    if (x.tag === "ExternalIntegration") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
            )
          )
        )
      );
    }
    if (x.tag === "AndroidApp") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "IosApp") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "Apetilo") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const genericExternalOrderOrigin = {
  to: x => {
    if (x.tag === "Inl") { return Takeaway; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Uber; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Glovo; }
        if (x._1._1.tag === "Inr") { return Wolt; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Takeaway") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Uber") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Glovo") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "Wolt") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))); }
    $runtime.fail();
  }
};
const showExternalOrderOrigin = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(TakeawayIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(UberIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(GlovoIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(WoltIsSymbol);
    return x => {
      const $4 = genericExternalOrderOrigin.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showOrderOrigin = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OnlineIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PhoneIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(BarIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PortalIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OtherIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PyszneIsSymbol);
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PizzaPortalIsSymbol);
    const $7 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})(CustomIsSymbol);
    const $8 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        "{ externalOrderOrigin: " + showExternalOrderOrigin.show(v.externalOrderOrigin) + ", integratorName: " + Data$dShow.showStringImpl(v.integratorName) + " " + "}"
      ]
    })(ExternalIntegrationIsSymbol);
    const $9 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(AndroidAppIsSymbol);
    const $10 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(IosAppIsSymbol);
    const $11 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ApetiloIsSymbol);
    return x => {
      const $12 = genericOrderOrigin.from(x);
      if ($12.tag === "Inl") { return $0["genericShow'"]($12._1); }
      if ($12.tag === "Inr") {
        if ($12._1.tag === "Inl") { return $1["genericShow'"]($12._1._1); }
        if ($12._1.tag === "Inr") {
          if ($12._1._1.tag === "Inl") { return $2["genericShow'"]($12._1._1._1); }
          if ($12._1._1.tag === "Inr") {
            if ($12._1._1._1.tag === "Inl") { return $3["genericShow'"]($12._1._1._1._1); }
            if ($12._1._1._1.tag === "Inr") {
              if ($12._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($12._1._1._1._1._1); }
              if ($12._1._1._1._1.tag === "Inr") {
                if ($12._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($12._1._1._1._1._1._1); }
                if ($12._1._1._1._1._1.tag === "Inr") {
                  if ($12._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($12._1._1._1._1._1._1._1); }
                  if ($12._1._1._1._1._1._1.tag === "Inr") {
                    if ($12._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($12._1._1._1._1._1._1._1._1); }
                    if ($12._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($12._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($12._1._1._1._1._1._1._1._1._1); }
                      if ($12._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($12._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($12._1._1._1._1._1._1._1._1._1._1); }
                        if ($12._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($12._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($12._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($12._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return $11["genericShow'"]($12._1._1._1._1._1._1._1._1._1._1._1); }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeExternalOrderOrigin = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericExternalOrderOrigin)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Takeaway"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Uber"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Glovo"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Wolt"), Data$dGeneric$dRep.NoArguments)]}))))(Unscramble$dEnum.defaultEnumOptions)
};
const unscrambleDecodeOrderOrigin = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(OnlineIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(PhoneIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(BarIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(PortalIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(OtherIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(PyszneIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(PizzaPortalIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(CustomIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Unscramble.decodeString(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ExternalIntegrationIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(externalOrderOriginIsSymbol)(unscrambleDecodeExternalOrderOrigin)(Unscramble.decodeRecordCons(integratorNameIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(AndroidAppIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(IosAppIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(ApetiloIsSymbol)))))))))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericOrderOrigin.to($0(x));
  })()
};
const boundedExternalOrderOrigi = /* #__PURE__ */ (() => (
  {
    top: genericExternalOrderOrigin.to(Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)))),
    bottom: genericExternalOrderOrigin.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordExternalOrderOrigin
  }
))();
const enumExternalOrderOrigin = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericExternalOrderOrigin)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericExternalOrderOrigin)(genericEnumSum1),
  Ord0: () => ordExternalOrderOrigin
};
const boundedEnumExternalOrderO = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericExternalOrderOrigin)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"](genericExternalOrderOrigin.from(x)),
    Bounded0: () => boundedExternalOrderOrigi,
    Enum1: () => enumExternalOrderOrigin
  }
))();
const toFillFormTypeExternalOrd = {
  fillFormDataType: /* #__PURE__ */ Restaumatic$dForm$dTestHelpers.defaultEnumFillFormDataType(genericExternalOrderOrigin)(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"Takeaway\""
  })(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({gdefaultEnumFillFormDataType: v => "\"Uber\""})(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"Glovo\""
  })({gdefaultEnumFillFormDataType: v => "\"Wolt\""}))))
};
const encodeExternalOrderOrigin = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericExternalOrderOrigin)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("Takeaway"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("Uber"); }
        if (v1._1.tag === "Inr") {
          if (v1._1._1.tag === "Inl") { return v.constructorTagTransform("Glovo"); }
          if (v1._1._1.tag === "Inr") { return v.constructorTagTransform("Wolt"); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const encodeOrderOrigin = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericOrderOrigin)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(OnlineIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(PhoneIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(BarIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(PortalIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(OtherIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor(PyszneIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $6 = Foreign$dGeneric$dClass.genericEncodeConstructor(PizzaPortalIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $7 = Foreign$dGeneric$dClass.genericEncodeConstructor(CustomIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
    });
    const $8 = Foreign$dGeneric$dClass.genericEncodeConstructor(ExternalIntegrationIsSymbol)((() => {
      const $8 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(integratorNameIsSymbol)(encodeWithOptionsOther))(externalOrderOriginIsSymbol)({
        encodeWithOptions: v => encodeExternalOrderOrigin.encode
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $8.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })());
    const $9 = Foreign$dGeneric$dClass.genericEncodeConstructor(AndroidAppIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $10 = Foreign$dGeneric$dClass.genericEncodeConstructor(IosAppIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $11 = Foreign$dGeneric$dClass.genericEncodeConstructor(ApetiloIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1.tag === "Inl") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1); }
                if (v1._1._1._1._1.tag === "Inr") {
                  if (v1._1._1._1._1._1.tag === "Inl") { return $5.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1); }
                  if (v1._1._1._1._1._1.tag === "Inr") {
                    if (v1._1._1._1._1._1._1.tag === "Inl") { return $6.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1); }
                    if (v1._1._1._1._1._1._1.tag === "Inr") {
                      if (v1._1._1._1._1._1._1._1.tag === "Inl") { return $7.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1); }
                      if (v1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (v1._1._1._1._1._1._1._1._1.tag === "Inl") { return $8.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1); }
                        if (v1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (v1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1); }
                          if (v1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (v1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                              return $10.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1);
                            }
                            if (v1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              return $11.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1);
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeExternalOrderOrigin = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericExternalOrderOrigin)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(TakeawayIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(UberIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(GlovoIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(WoltIsSymbol)))))
};
const decodeOrderOrigin = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericOrderOrigin)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OnlineIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PhoneIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(BarIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PortalIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OtherIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PyszneIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PizzaPortalIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(CustomIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ExternalIntegrationIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(integratorNameIsSymbol)(decodeWithOptionsOther)())(externalOrderOriginIsSymbol)({
    decodeWithOptions: v => decodeExternalOrderOrigin.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AndroidAppIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(IosAppIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ApetiloIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))))))))))
};
export {
  $ExternalOrderOrigin,
  $OrderOrigin,
  AndroidApp,
  AndroidAppIsSymbol,
  Apetilo,
  ApetiloIsSymbol,
  Bar,
  BarIsSymbol,
  Custom,
  CustomIsSymbol,
  ExternalIntegration,
  ExternalIntegrationIsSymbol,
  Glovo,
  GlovoIsSymbol,
  IosApp,
  IosAppIsSymbol,
  Online,
  OnlineIsSymbol,
  Other,
  OtherIsSymbol,
  Phone,
  PhoneIsSymbol,
  PizzaPortal,
  PizzaPortalIsSymbol,
  Portal,
  PortalIsSymbol,
  Pyszne,
  PyszneIsSymbol,
  Takeaway,
  TakeawayIsSymbol,
  Uber,
  UberIsSymbol,
  Wolt,
  WoltIsSymbol,
  boundedEnumExternalOrderO,
  boundedExternalOrderOrigi,
  decodeExternalOrderOrigin,
  decodeOrderOrigin,
  decodeWithOptionsOther,
  encodeExternalOrderOrigin,
  encodeOrderOrigin,
  encodeWithOptionsOther,
  enumExternalOrderOrigin,
  eqExternalOrderOrigin,
  eqOrderOrigin,
  externalOrderOriginIsSymbol,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericExternalOrderOrigin,
  genericOrderOrigin,
  genericTopConstructor,
  integratorNameIsSymbol,
  ordExternalOrderOrigin,
  ordOrderOrigin,
  showExternalOrderOrigin,
  showOrderOrigin,
  toFillFormTypeExternalOrd,
  toFillFormTypeOrderOrigin,
  unscrambleDecodeExternalOrderOrigin,
  unscrambleDecodeOrderOrigin
};
